import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useBankBalanceService() {
  const { apiClientInstance } = useAPIClientHelper();

  /**
   * Balances for the dashboard widget — accounts with a live ISO 20022 bank
   * connection that the company has chosen to show.
   *
   * Errors are silent: the dashboard renders this widget without the user
   * asking for it, so a toast about bank balances would come out of nowhere.
   * The widget shows its explanatory empty state instead.
   */
  const getDashboardBalances = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: false,
    })
      .BankBalanceClient.GetDashboardBalances()
      .then((res) => res.data);
  };

  /**
   * Every account that can be shown or hidden, including the hidden ones, so
   * settings can offer a toggle per account. Errors surface here — the user
   * opened the settings screen deliberately.
   */
  const getVisibilitySettings = () => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .BankBalanceClient.GetVisibilitySettings()
      .then((res) => res.data);
  };

  const updateVisibilitySettings = (changes: WintSuperkollAPIModel.BankBalanceVisibilityPut[]) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).BankBalanceClient.UpdateVisibilitySettings(changes);
  };

  return {
    getDashboardBalances,
    getVisibilitySettings,
    updateVisibilitySettings,
  };
}

export default useBankBalanceService;
